module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "h-6 w-6 stroke-current text-blue-dark"
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "fill": "none",
      "stroke-miterlimit": "10"
    }
  }, [_c('path', {
    attrs: {
      "data-color": "color-2",
      "stroke-linecap": "square",
      "d": "M2.5 16.5v6h20v-6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-cap": "butt",
      "d": "M12.5 17.5v-15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "square",
      "d": "M18.5 8.5l-6-6-6 6"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4b816d0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/TransportLabelSVG.vue
// module id = 621
// module chunks = 66